import { ActivityLogReport } from "../../../components/Reports/ActivityLogReport";
import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";

export interface IActivityLogReportPage {}

export const ActivityLogReportPage: FC<IActivityLogReportPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Client Activity Log Report"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<ActivityLogReport />}
    />
  );
};
